import { Link } from 'react-router-dom';
import { useTitle } from '@/lib/useTitle';
import DimensionLine from '@/components/DimensionLine';

export default function NotFound() {
  useTitle('Page not found');

  return (
    <section className="relative bg-grid-sheet">
      <span className="sheet-no absolute right-5 top-5 sm:right-8">X-00</span>

      <div className="animate-fade-in mx-auto max-w-2xl px-5 py-32 text-center">
        <p className="font-display text-[76px] leading-none text-medline">404</p>
        <DimensionLine label="Sheet not issued" className="mx-auto mt-6 max-w-xs" />
        <h1 className="mt-8 font-display text-[36px] font-semibold leading-tight">Page not found</h1>
        <p className="mt-4 leading-relaxed text-annot">
          The page you're after doesn't exist, or the link is out of date.
        </p>
        <div className="mt-9 flex justify-center gap-3">
          <Link to="/" className="btn-primary">Back to home</Link>
          <Link to="/contact" className="btn-ghost">Get in touch</Link>
        </div>
      </div>
    </section>
  );
}
